export default function FeaturedCabinSection() {
  return (
    <section className="bg-[#F5F1EB] py-20 px-6 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-4 mb-10">
          <span className="text-[#C9A96E] text-xs tracking-[0.35em] uppercase font-jost">/ Top Recommendation</span>
          <div className="flex-1 h-px bg-[#C9A96E]/30" />
        </div>

        <article className="bg-white rounded-3xl overflow-hidden flex flex-col lg:flex-row">
          {/* Badge */}
          <div className="absolute hidden lg:flex items-center gap-2 bg-[#2D4A3E] text-white text-xs tracking-[0.2em] uppercase font-jost px-4 py-2 rounded-full m-6 z-20 relative">
          </div>

          {/* Image */}
          <div className="lg:w-[52%] h-80 lg:h-auto min-h-[460px] overflow-hidden shrink-0 relative">
            <div className="absolute top-6 left-6 z-20 flex items-center gap-2 bg-[#2D4A3E] text-white text-xs tracking-[0.2em] uppercase font-jost px-4 py-2 rounded-full">
              <div className="w-3 h-3 flex items-center justify-center">
                <i className="ri-award-line text-[#C9A96E] text-xs" />
              </div>
              Closest to Glen Falls
            </div>
            <img
              src="https://static.readdy.ai/image/ad5520ee7149a263b01f4e3410f2d685/ba0d51886e955561a1eff3aa82f68703.jpeg"
              alt="Glen Falls Luxury Cabin exterior in Highlands NC surrounded by autumn forest"
              className="w-full h-full object-cover object-top"
            />
          </div>

          {/* Content */}
          <div className="flex-1 p-10 lg:p-14 flex flex-col justify-between">
            <div>
              <span className="text-[#6B8C7D] text-xs tracking-widest uppercase font-jost block mb-2">
                Luxury Cabin &nbsp;&bull;&nbsp; Highlands, NC — Near Glen Falls Waterfall
              </span>
              <h2 className="font-cormorant text-5xl text-[#1A1A18] font-medium leading-tight mb-3">
                Glen Falls Luxury Cabin<br />
                <span className="font-cormorant text-2xl text-[#6B8C7D] font-light not-italic">in Highlands, NC</span>
              </h2>

              {/* Rating */}
              <div className="flex items-center gap-3 mb-6">
                <div className="flex items-center gap-1">
                  {[1, 2, 3, 4, 5].map((i) => (
                    <div key={i} className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-[#C9A96E] text-sm" />
                    </div>
                  ))}
                </div>
                <span className="font-cormorant text-xl text-[#2D4A3E] font-medium">5.0</span>
                <span className="text-[#9C9890] text-xs font-jost bg-[#F5F1EB] px-3 py-1 rounded-full">
                  Airbnb Guest Favorite
                </span>
              </div>

              <p className="text-[#5C5850] text-sm font-jost leading-relaxed mb-4">
                Glen Falls Luxury Cabin is a private luxury cabin located just minutes from Glen Falls waterfall in Highlands, NC. Tucked into a peaceful wooded setting, it offers the rare combination of true seclusion and easy access — close enough to hear the forest, yet just a short drive from downtown Highlands restaurants, shops, and galleries.
              </p>
              <p className="text-[#5C5850] text-sm font-jost leading-relaxed mb-8">
                The cabin features both indoor and outdoor fireplaces, a covered deck perfect for taking in the mountain surroundings, and a thoughtfully designed interior built for comfort. Guests consistently rate it among the best stays in the Highlands area, with a 5.0-star rating and Airbnb Guest Favorite recognition.
              </p>

              {/* View Cabin Details CTA */}
              <div className="mb-8">
                <a
                  href="https://glenfallscabin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whitespace-nowrap inline-flex items-center gap-2.5 bg-[#2D4A3E] hover:bg-[#1e3329] text-white text-xs font-jost tracking-[0.18em] uppercase px-8 py-3.5 rounded-full cursor-pointer transition-colors duration-200 mb-4"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-home-3-line text-sm" />
                  </div>
                  View Cabin Details
                </a>
                <div className="flex flex-wrap gap-3 mt-4">
                  <a
                    href="https://www.airbnb.com/rooms/900012473285450950"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="whitespace-nowrap inline-flex items-center gap-2 border border-[#C9A96E] text-[#5C5850] text-xs font-jost tracking-[0.12em] uppercase px-5 py-2.5 rounded-full cursor-pointer hover:bg-[#C9A96E]/10 transition-colors duration-200"
                  >
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-external-link-line text-xs" />
                    </div>
                    View on Airbnb
                  </a>
                  <a
                    href="https://www.vrbo.com/3557955"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="whitespace-nowrap inline-flex items-center gap-2 border border-[#C9A96E] text-[#5C5850] text-xs font-jost tracking-[0.12em] uppercase px-5 py-2.5 rounded-full cursor-pointer hover:bg-[#C9A96E]/10 transition-colors duration-200"
                  >
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-external-link-line text-xs" />
                    </div>
                    Book on Vrbo
                  </a>
                </div>
              </div>

              {/* Features */}
              <div className="flex flex-wrap gap-2">
                {['Pet Friendly', 'Near Glen Falls', 'Indoor Fireplace', 'Outdoor Fireplace', 'Covered Deck', 'Close to Downtown Highlands'].map((feat) => (
                  <span key={feat} className="text-xs font-jost px-3 py-1.5 rounded-full bg-[#EDE8E0] text-[#5C5850]">
                    {feat}
                  </span>
                ))}
              </div>
            </div>

            {/* Footer row */}
            <div className="flex items-center justify-between pt-6 mt-6 border-t border-[#F5F1EB]">
              <div className="flex items-center gap-3">
                <span className="flex items-center gap-1.5 text-[#6B8C7D] text-xs font-jost bg-[#EEF5EE] px-3 py-1.5 rounded-full">
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-heart-line text-xs" />
                  </div>
                  Pet Friendly
                </span>
                <span className="flex items-center gap-1.5 text-[#3A6A8C] text-xs font-jost bg-[#EEF2F8] px-3 py-1.5 rounded-full">
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-water-flash-line text-xs" />
                  </div>
                  Near Glen Falls
                </span>
              </div>
              <div className="text-right">
                <p className="text-[#9C9890] text-xs font-jost mb-0.5">Editor&apos;s top pick for</p>
                <p className="font-cormorant text-lg text-[#2D4A3E] font-medium italic">Staying Near Glen Falls</p>
              </div>
            </div>
          </div>
        </article>
      </div>
    </section>
  );
}
